import React, { useRef, useState, useCallback, useMemo, useEffect } from "react";
import {
    Home,
    Package,
    ShoppingCart,
    UserPlus,
    Users,
    FileText,
    ReceiptIndianRupee,
    Wallet,
    School,
    Layers,
    Menu as MenuIcon,
    MessageSquare,
    Wallet2,
    Image,
    Megaphone,
    ChevronRight,
    ChevronDown,
    ChevronsUpDown,
    Settings,
    LogOut,
    Menu,
    SidebarClose,
    X,
    HelpCircle,
    LayoutDashboard,
    History,
    LayoutGrid,
    ClipboardCheck,
    ListTodo,
    Globe,
    Palette,
    BookOpen,
    FolderTree,
    Award,
    Newspaper,
    UsersRound,
} from "lucide-react";
import { useNavigate, useLocation, NavLink } from "react-router-dom";
import { getDecryptedUserFromCookie } from './utils/getCookie';
import usermain from "../Img/user.png";
import sidebarLogo from "../Img/de.png";
import "./SideBar.css";

const isStaffUser = (u) => String(u?.type ?? "").toLowerCase() === "staff";

/** Minimal navigation for staff accounts (no admin catalogue / site tools). */
const staffMenuData = [
    { title: "Dashboard", icon: Home, path: "/", type: "link" },
    { title: "Attendance", icon: ClipboardCheck, path: "/attendance", type: "link" },
    { title: "Tasks", icon: ListTodo, path: "/tasks", type: "link" },
    { title: "CRM", icon: UserPlus, path: "/crm", type: "link" },
    { title: "Orders", icon: ShoppingCart, path: "/orders", type: "link" },
];

const menuData = [
    { title: "Dashboard", icon: Home, path: "/", type: "link" },
    //  { title: "Orders", icon: ShoppingCart, path: "/", type: "link", badge: "100" },
    {
        title: "Inventory",
        icon: Package,
        type: "accordion",
        submenus: [
            { title: "Product / Services", path: "/products", type: "link" },
            { title: "Grouped Products", path: "/grouped-product", type: "link" },
            // { title: "Units", path: "/unit", visibleFor: "Admin", type: "link" },
            { title: "Pincode", path: "/pincode", visibleFor: "Admin", type: "link" },
            { title: "Delivery", path: "/delivery", visibleFor: "Admin", type: "link" },
            { title: "Variations", path: "/features", visibleFor: "Admin", type: "link" },
            { title: "Categories", path: "/category", visibleFor: "Admin", type: "link" },
            { title: "Coupon", path: "/coupon", visibleFor: "Admin", type: "link" },

        ],
    },
    { title: "Orders", icon: ShoppingCart, path: "/orders", type: "link", badge: "100" },
    { title: "CRM", icon: UserPlus, path: "/crm", type: "link" },
    { title: "Customer", icon: Users, path: "/customer", type: "link" },
    { title: "Invoice", icon: FileText, path: "/invoice", type: "link" },
    { title: "Receipt", icon: ReceiptIndianRupee, path: "/receipt", type: "link" },
    { title: "Expense", icon: Wallet, path: "/expense", type: "link" },
    { title: "Blog", icon: Newspaper, path: "/blog", type: "link" },
    { title: "Admission", icon: School, path: "/admission", type: "link", visibleFor: "Admin", visibleSk: "Skates" },
    { title: "Attendance", icon: ClipboardCheck, path: "/student-attendance", type: "link", visibleFor: "Admin", visibleSk: "Skates" },
    { title: "Batches", icon: LayoutGrid, path: "/admission-batches", type: "link", visibleFor: "Admin", visibleSk: "Skates" },
    { title: "Centers", icon: School, path: "/admission-centers-settings", type: "link", visibleFor: "Admin", visibleSk: "Skates" },
    { title: "Category", icon: Layers, path: "/category-main", type: "link", visibleFor: "SuperAdmin" },
    { title: "All user records", icon: Users, path: "/alluser-records", type: "link", visibleFor: "SuperAdmin" },
    {
        title: "Website / App",
        icon: Globe,
        type: "accordion",
        submenus: [
            { title: "Users", path: "/user-records", visibleFor: "Admin", type: "link" },
            { title: "Slider", path: "/slider", visibleFor: "Admin", type: "link" },
            { title: "Track Slider", path: "/track-slider", visibleFor: "Admin", type: "link" },
            { title: "Hero Section", path: "/herosection", visibleFor: "Admin", type: "link" },
            { title: "Home Sections", path: "/newarrival", visibleFor: "Admin", type: "link" },
            { title: "Call To Action1", path: "/calltoactionfirst", visibleFor: "Admin", type: "link" },
            { title: "Call To Action2", path: "/calltoactionsecond", visibleFor: "Admin", type: "link" },
            { title: "Review", path: "/review", visibleFor: "Admin", type: "link" },
            { title: "Offers", path: "/offer", visibleFor: "Admin", type: "link" },

        ],
    },
    {
        title: "Customization",
        icon: Palette,
        type: "accordion",
        submenus: [
            { title: "Headline", path: "/headline", visibleFor: "Admin", type: "link" },
            { title: "Footer", path: "/footer-setting", visibleFor: "Admin", type: "link" },
            { title: "Request Callback", path: "/calltoaction-form", visibleFor: "Admin", type: "link" },
            { title: "Footer Setting", path: "/footer-setting", visibleFor: "Admin", type: "link" },

        ],
    },
    {
        title: "Blogs",
        icon: BookOpen,
        type: "accordion",
        submenus: [
            { title: "Blogs", path: "/blog", visibleFor: "Admin", type: "link" },
            { title: "Add Blog", path: "/add-blog", visibleFor: "Admin", type: "link" },
            { title: "Authors", path: "/author", visibleFor: "Admin", type: "link" },
            { title: "Comments", path: "/comment", visibleFor: "Admin", type: "link" },
            { title: "Category", path: "/blog-category", visibleFor: "Admin", type: "link" },

        ],
    },
    {
        title: "Catlog",
        icon: FolderTree,
        type: "accordion",
        submenus: [
            { title: "Catlog Category", path: "/catlog-catgeory", visibleFor: "Admin", type: "link" },
            { title: "Catlog", path: "/catlog", visibleFor: "Admin", type: "link" },

        ],
    },
    { title: "Menus", icon: MenuIcon, path: "/menus", type: "link", visibleFor: "Admin" },
    // {
    //     title: "Referral",
    //     icon: Users,
    //     type: "accordion",
    //     submenus: [
    //         { title: "Create refer", path: "/refer", type: "link" },
    //         { title: "Referral Usage", path: "/refer-usage", type: "link" },
    //     ],
    //     visibleFor: "Admin",
    // },
    { title: "Wallet", icon: Wallet2, path: "/wallet-target", type: "link", visibleFor: "Admin" },
    { title: "Testimonial", icon: MessageSquare, path: "/testimonial", type: "link", visibleFor: "Admin" },
    { title: "Brand", icon: Award, path: "/brand", type: "link", visibleFor: "Admin" },
    // { title: "Product Banner", icon: Box, path: "/productbanner", type: "link", visibleFor: "Admin" }, 
    // { title: "Plan", icon: Layers, path: "/plan", type: "link", visibleFor: "SuperAdmin" },
    { title: "Media Library", icon: Image, path: "/media", type: "link", visibleFor: "Admin" },
    {
        title: "Teams",
        icon: UsersRound,
        type: "accordion",
        submenus: [
            { title: "Department", path: "/departments", type: "link" },
            { title: "Team Directory", path: "/team-directory", type: "link" },
            { title: "Team Attendance", path: "/team-attendance", type: "link" },
            { title: "Tasks", path: "/tasks", type: "link" },
        ],
    },
    { title: "Google Ads", icon: Megaphone, path: "/integrations", type: "link" },
];

const Sidebar = ({
    collapsed,
    setCollapsed,
    mobileOpen,
    setMobileOpen,
    isMobile,
    onCloseMobile,
    totalnewOrder
}) => {
    const [openAccordions, setOpenAccordions] = useState({});
    const [tooltip, setTooltip] = useState(null);
    const dropdownRef = useRef(null);
    const sidebarRef = useRef(null);
    const user = getDecryptedUserFromCookie();
    const userType = user?.type;
    const userCategory = user?.category;
    const navigate = useNavigate();
    const location = useLocation();

    const isPathActive = useCallback(
        (path) => {
            if (!path) return false;
            const p = location.pathname;
            if (path === "/") return p === "/";
            if (path === "/attendance") {
                return p === "/attendance" || p === "/student-attendance" || p.startsWith("/student-attendance/");
            }
            return p === path || p.startsWith(path + "/");
        },
        [location.pathname]
    );

    const hasActiveDescendant = useCallback(
        (item) => {
            if (!item?.submenus?.length) return false;
            return item.submenus.some((sub) => {
                if (sub.type === "link" && sub.path) return isPathActive(sub.path);
                if (sub.type === "accordion") return hasActiveDescendant(sub);
                return false;
            });
        },
        [isPathActive]
    );

    const toggleAccordion = (id) => {
        setOpenAccordions((prev) => {
            if (prev[id]) {
                return { ...prev, [id]: false };
            }
            // Only one accordion open at a time
            return { [id]: true };
        });
    };

    const handleAccordionClick = (id) => {
        if (collapsed && !isMobile) {
            setCollapsed(false);
            setOpenAccordions({ [id]: true });
            return;
        }
        toggleAccordion(id);
    };

    const handleCollapse = () => {
        setOpenAccordions({});
        setCollapsed(true);
    };

    const showTooltip = (e, title) => {
        if (!collapsed || isMobile) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            title,
            top: rect.top + rect.height / 2,
        });
    };

    const hideTooltip = () => setTooltip(null);

    const dynamicMenuData = useMemo(() => {
        const base = isStaffUser(user) ? staffMenuData : menuData;
        return base.map((item) => {
            if (item.title === "Orders") {
                return {
                    ...item,
                    badge: totalnewOrder > 0 ? String(totalnewOrder) : undefined,
                };
            }
            return item;
        });
    }, [totalnewOrder, userType]);

    const handlelogout = async () => {
        try {
            localStorage.removeItem("2xgxgshdugyywerw12eccom");
            localStorage.removeItem("2xgxgshdugyywerw12gh");
            navigate("/login");
        } catch (err) {
            console.error("Logout failed:", err);
        }
    };

    const filteredNavItems = useMemo(
        () =>
            dynamicMenuData
                .filter((item) => {
                    if (item.hidden) return false;

                    const userTypeMatches = !item.visibleFor || item.visibleFor === userType;
                    const normSk = (s) =>
                        String(s ?? "").trim().toLowerCase().replace(/\s+/g, " ");
                    const catNorm = normSk(userCategory);
                    const need = normSk(item.visibleSk);
                    const visibleSkMatches =
                        !item.visibleSk ||
                        catNorm === need ||
                        (need === "skates" && catNorm.includes("skates"));

                    return userTypeMatches && visibleSkMatches;
                })
                .map((item) => {
                    if (item.submenus) {
                        const filteredSubNav = item.submenus.filter(
                            (sub) => !sub.visibleFor || sub.visibleFor === userType
                        );
                        return { ...item, submenus: filteredSubNav };
                    }
                    return item;
                })
                .filter((item) => !item.submenus || item.submenus.length > 0),
        [dynamicMenuData, userType, userCategory]
    );

    // Auto-open accordions only when the route changes — not on every render.
    // Merging active-route accordions into state on each render prevented manual close.
    useEffect(() => {
        const p = location.pathname;
        const pathActive = (path) => {
            if (!path) return false;
            if (path === "/") return p === "/";
            if (path === "/attendance") {
                return p === "/attendance" || p === "/student-attendance" || p.startsWith("/student-attendance/");
            }
            return p === path || p.startsWith(path + "/");
        };
        const subtreeActive = (sub) => {
            if (sub.type === "link" && sub.path) return pathActive(sub.path);
            if (sub.type === "accordion" && sub.submenus?.length)
                return sub.submenus.some(subtreeActive);
            return false;
        };
        const toOpen = {};
        const walk = (items, parentId = "") => {
            for (const item of items) {
                const id = `${parentId}-${item.title}`;
                if (item.type === "accordion" && item.submenus?.length) {
                    if (item.submenus.some(subtreeActive)) toOpen[id] = true;
                    walk(item.submenus, id);
                }
            }
        };
        walk(filteredNavItems);
        setOpenAccordions(toOpen);
    }, [location.pathname, filteredNavItems]);


    const renderMenuItem = (item, parentId = "", depth = 0) => {
        const itemId = `${parentId}-${item.title}`;
        const isOpen = openAccordions[itemId];
        const Icon = item.icon;
        const showExpanded = !collapsed || isMobile;

        const childActive = item.type === "accordion" && hasActiveDescendant(item);
        const linkActive = item.type === "link" && item.path && isPathActive(item.path);
        const isActive = Boolean(linkActive || childActive);

        const linkClass = [
            "app-sidebar__link",
            isActive ? "app-sidebar__link--active" : "",
            collapsed && !isMobile ? "app-sidebar__link--collapsed" : "",
            item.type === "accordion" && isOpen ? "app-sidebar__link--accordion-open" : "",
            depth > 0 ? "app-sidebar__link--depth" : "",
        ]
            .filter(Boolean)
            .join(" ");

        const linkBody = (
            <>
                {Icon && <Icon className="app-sidebar__glyph" strokeWidth={2} />}
                {showExpanded && (
                    <>
                        <span className="app-sidebar__label">{item.title}</span>
                        {item.badge && (
                            <span className="app-sidebar__badge">{item.badge}</span>
                        )}
                        {item.type === "accordion" && (
                            <span className="app-sidebar__chevron" aria-hidden>
                                {isOpen ? (
                                    <ChevronDown className="size-4" strokeWidth={2} />
                                ) : (
                                    <ChevronRight className="size-4" strokeWidth={2} />
                                )}
                            </span>
                        )}
                    </>
                )}
            </>
        );

        if (item.type === "link") {
            return (
                <li key={itemId}>
                    <NavLink
                        to={item.path}
                        end={item.path === "/"}
                        onClick={() => isMobile && onCloseMobile()}
                        onMouseEnter={(e) => showTooltip(e, item.title)}
                        onMouseLeave={hideTooltip}
                        className={linkClass}
                    >
                        {linkBody}
                    </NavLink>
                </li>
            );
        }

        const button = (
            <button
                type="button"
                onClick={() => handleAccordionClick(itemId)}
                onMouseEnter={(e) => showTooltip(e, item.title)}
                onMouseLeave={hideTooltip}
                className={linkClass}
            >
                {linkBody}
            </button>
        );

        const panelOpen = isOpen && showExpanded;

        return (
            <li key={itemId}>
                {button}
                <div
                    className={`app-sidebar__accordion-panel${panelOpen ? " is-open" : ""}`}
                >
                    <ul
                        className={`app-sidebar__sublist${depth === 0 ? " app-sidebar__sublist--root" : ""}`}
                    >
                        {item.submenus &&
                            item.submenus.map((sub) =>
                                renderMenuItem(sub, itemId, depth + 1)
                            )}
                    </ul>
                </div>
            </li>
        );
    };

    const sidebarWidth = isMobile
        ? mobileOpen
            ? "w-60"
            : "w-0"
        : collapsed
            ? "w-16"
            : "w-60";

    return (
        <>
            <div
                ref={sidebarRef}
                className={`app-sidebar fixed top-0 start-0 bottom-0 z-[130] flex flex-col overflow-hidden transition-all duration-300 ease-in-out ${sidebarWidth} h-full`}
            >
                <header
                    className={`app-sidebar__header${collapsed && !isMobile ? " app-sidebar__header--collapsed-desktop" : ""}`}
                >
                    {collapsed && !isMobile ? (
                        <>
                            <div
                                role="button"
                                tabIndex={0}
                                onClick={() => {
                                    navigate("/");
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        navigate("/");
                                    }
                                }}
                                className="app-sidebar__logo max-w-12"
                            >
                                <img src={sidebarLogo} alt="logo" />
                            </div>
                            <button
                                type="button"
                                onClick={() => setCollapsed(false)}
                                className="app-sidebar__icon-btn"
                                aria-label="Expand sidebar"
                            >
                                <MenuIcon className="size-5" strokeWidth={2} />
                            </button>
                        </>
                    ) : (
                        <>
                            <div className="flex-1 min-w-0" aria-hidden />
                            <div
                                role="button"
                                tabIndex={0}
                                onClick={() => {
                                    navigate("/");
                                    if (isMobile) onCloseMobile();
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        navigate("/");
                                        if (isMobile) onCloseMobile();
                                    }
                                }}
                                className="app-sidebar__logo max-w-[5rem]"
                            >
                                <img src={sidebarLogo} alt="logo" />
                            </div>
                            <div className="flex-1 flex justify-end">
                                {!isMobile ? (
                                    <button
                                        type="button"
                                        onClick={handleCollapse}
                                        className="app-sidebar__icon-btn"
                                        aria-label="Collapse sidebar"
                                    >
                                        <SidebarClose className="size-5" strokeWidth={2} />
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        onClick={onCloseMobile}
                                        className="app-sidebar__icon-btn"
                                        aria-label="Close menu"
                                    >
                                        <X className="size-5" strokeWidth={2} />
                                    </button>
                                )}
                            </div>
                        </>
                    )}
                </header>

                <nav className="app-sidebar__nav" aria-label="Main">
                    <ul className="app-sidebar__list">
                        {filteredNavItems.map((i) => renderMenuItem(i))}
                    </ul>
                </nav>

                <footer className="app-sidebar__footer">
                    <UserDropdown
                        collapsed={collapsed}
                        setCollapsed={setCollapsed}
                        isMobile={isMobile}
                        navigate={navigate}
                        dropdownRef={dropdownRef}
                        user={user}
                        handlelogout={handlelogout}
                        isStaff={isStaffUser(user)}
                    />
                </footer>
            </div>

            {tooltip && collapsed && !isMobile && (
                <div
                    className="app-sidebar__tooltip whitespace-nowrap"
                    style={{
                        left: sidebarRef.current?.getBoundingClientRect().right + 8,
                        top: tooltip.top,
                        transform: "translateY(-50%)",
                    }}
                >
                    {tooltip.title}
                </div>
            )}

            {isMobile && !mobileOpen && (
                <div className="app-sidebar__mobile-bar">
                    <button
                        type="button"
                        className="app-sidebar__mobile-icon-btn"
                        onClick={() => setMobileOpen(true)}
                        aria-label="Open menu"
                    >
                        <Menu className="size-6" strokeWidth={2} />
                    </button>
                    <div className="app-sidebar__mobile-bar-actions">
                        <button
                            type="button"
                            className="app-sidebar__mobile-icon-btn"
                            onClick={() => navigate("/")}
                            aria-label="Dashboard"
                        >
                            <LayoutDashboard className="size-6" strokeWidth={2} />
                        </button>
                        <button
                            type="button"
                            className="app-sidebar__mobile-icon-btn"
                            onClick={() => navigate("/history")}
                            aria-label="History"
                        >
                            <History className="size-6" strokeWidth={2} />
                        </button>
                        <div className="app-sidebar__mobile-avatar">
                            <img src={usermain} alt="" />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const UserDropdown = ({ collapsed, setCollapsed, isMobile, navigate, dropdownRef, user, handlelogout, isStaff }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [tooltip, setTooltip] = useState(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        if (collapsed && !isMobile) {
            setDropdownOpen(false);
        }
    }, [collapsed, isMobile]);

    const showTooltip = (e, text) => {
        if (!collapsed || isMobile) return;
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            text,
            top: rect.top + rect.height / 2,
            left: rect.right + 8,
        });
    };

    const hideTooltip = () => setTooltip(null);

    const menuItems = [
        ...(!isStaff ? [{ icon: Settings, text: "Settings", onClick: () => navigate("/setting") }] : []),
        { icon: HelpCircle, text: "Help & Support", onClick: () => navigate("/help-support") },
        { icon: LogOut, text: "Sign out", onClick: handlelogout },
    ];

    return (
        <div ref={dropdownRef} className="relative">
            <button
                type="button"
                ref={buttonRef}
                onClick={() => {
                    if (collapsed && !isMobile) {
                        setCollapsed(false);
                        setDropdownOpen(true);
                        return;
                    }
                    setDropdownOpen((o) => !o);
                }}
                onMouseEnter={(e) => showTooltip(e, user?.full_name || "User")}
                onMouseLeave={hideTooltip}
                className={`app-sidebar__user-btn${collapsed && !isMobile ? " app-sidebar__user-btn--collapsed" : ""}`}
            >
                <img
                    className="app-sidebar__user-avatar"
                    src={usermain}
                    alt=""
                />
                {(!collapsed || isMobile) && (
                    <div className="app-sidebar__user-text">
                        <p className="app-sidebar__user-name">
                            {user?.full_name || "User"}
                        </p>
                        <p className="app-sidebar__user-email">
                            {user?.email || ""}
                        </p>
                    </div>
                )}
                {(!collapsed || isMobile) && (
                    <ChevronsUpDown
                        className={`app-sidebar__user-chevron${dropdownOpen ? " app-sidebar__user-chevron--open" : ""}`}
                    />
                )}
            </button>

            <div
                className={`app-sidebar__dropdown${collapsed && !isMobile ? " app-sidebar__dropdown--collapsed" : ""} ${
                    dropdownOpen
                        ? "opacity-100 visible translate-y-0"
                        : "opacity-0 invisible translate-y-1 pointer-events-none"
                }`}
            >
                {menuItems.map((item, idx) => {
                    const Icon = item.icon;
                    return (
                        <button
                            type="button"
                            key={idx}
                            onClick={() => {
                                item.onClick();
                                setDropdownOpen(false);
                            }}
                            onMouseEnter={(e) => showTooltip(e, item.text)}
                            onMouseLeave={hideTooltip}
                            className="app-sidebar__dropdown-item"
                        >
                            <Icon className="app-sidebar__glyph" strokeWidth={2} />
                            {(!collapsed || isMobile) && <span>{item.text}</span>}
                        </button>
                    );
                })}
            </div>

            {tooltip && collapsed && !isMobile && (
                <div
                    className="app-sidebar__tooltip whitespace-nowrap"
                    style={{
                        left: tooltip.left,
                        top: tooltip.top,
                        transform: "translateY(-50%)",
                    }}
                >
                    {tooltip.text}
                </div>
            )}
        </div>
    );
};

export default Sidebar;